<template>
    <div>
        <el-row :gutter="1" v-if="productType === 'sessions'">
    <el-col :span="6"  v-for="product in SessionsProducts" :key="product.name"  class="productWrapper">
        <div class="product-box">
            <img class="productImage" src="../assets/images/workout.png">
            <div class="productInfo">
                <p class="name-info">{{  product.name }}</p>
                <span>$ {{ product.price }}</span>
            </div>
            <div class="mt-2">
                <button class="btn btn-primary" @click="addToCart(product)">Add to cart</button>
            </div>
        </div>
    </el-col>
  </el-row>
  <el-row :gutter="1" v-if="productType === 'coins'">
    <el-col :span="6"  v-for="product in CoinsProducts" :key="product.name"  class="productWrapper">
        <div class="product-box">
            <img class="productImage" src="../assets/images/tokens.png">
            <div class="productInfo">
                <p class="name-info">{{  product.name }}</p>
                <span>$ {{ product.price }}</span>
            </div>
            <div class="mt-2">
                <button class="btn btn-primary" @click="addToCart(product)">Add to cart</button>
            </div>
        </div>
    </el-col>
  </el-row>
  <el-row :gutter="1" v-if="productType === 'devices'">
    <el-col :span="6"  v-for="product in DeviceProducts" :key="product.name"  class="productWrapper">
        <div class="product-box">
            <img class="productImage rounded" v-if="product.name === 'Glove'" src="../assets/images/glove.png">
            <img class="productImage rounded" v-if="product.name === 'Knee Sleeve'" src="../assets/images/knee_sleeve.png">
            <img class="productImage rounded" v-if="product.name === 'Neat'" src="../assets/images/neat.png">
            <img class="productImage rounded" v-if="product.name === 'Pants'" src="../assets/images/knee_sleeve.png">
            <img class="productImage rounded" v-if="product.name === 'Band'" src="../assets/images/band.jpg">

            <div class="productInfo">
                <p class="name-info">{{  product.name }}</p>
                <span>$ {{ product.price }}</span>
            </div>
            <div class="mt-2">
                <button class="btn btn-primary" @click="requestInvoice()">Request invoice</button>
            </div>
        </div>
    </el-col>
  </el-row>
    </div>
</template>

<script>
import SessionsProducts from '../FackApi/json/SessionsProducts.json'
import DeviceProducts from '../FackApi/json/DeviceProducts.json'
import CoinsProducts from '../FackApi/json/CoinsProducts.json'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'PurchaseableSessions',
  props: ['productType'],
  setup () {
    const sessionsImage = require('../assets/images/workout.png')
    const store = useStore()

    const addProductToCart = (product) => store.dispatch('shoppingCart/addProductToCart', product)

    const addToCart = (product) => {
      addProductToCart(product)
    }

    const router = useRouter()

    const requestInvoice = () => {
      router.push({ name: 'patient.requestInvoice' })
    }

    return {
      SessionsProducts,
      addToCart,
      sessionsImage,
      DeviceProducts,
      requestInvoice,
      CoinsProducts
    }
  }
}
</script>

<style>
    .productImage {
        width: 50%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
    }

    .product-box {
        border: solid 1px var(--border-color);
        width: 90%;
        padding: 15px;
        text-align: center;
        margin-bottom: 25px;
        color: black;
    }

    .productInfo{
        margin-top: 10px;
    }

    .name-info {
        margin: 15px 0;
        margin-bottom: 0 !important;
    }

    .cartImage {
        width: 60%;
    }

    span {
        color: var(--muted-text-color);
    }
</style>
